import config from './seo-config'
import { syncStructuredData } from './structured-data'

export function applyPageSeo(pathname: string) {
  const page = (config.pages as Record<string, { title: string; description: string }>)[pathname]
  const title = page?.title ?? 'Page not found | China Care'
  const description = page?.description ?? 'This page could not be found. Explore patient support, consultation fees and treatment planning with China Care.'
  document.title = title
  const setMeta = (attribute: 'name' | 'property', key: string, value: string) => {
    let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`)
    if (!tag) { tag = document.createElement('meta'); tag.setAttribute(attribute, key); document.head.appendChild(tag) }
    tag.content = value
  }
  setMeta('name', 'description', description)
  setMeta('name', 'robots', page ? 'index, follow' : 'noindex, follow')
  setMeta('property', 'og:title', title)
  setMeta('property', 'og:description', description)
  setMeta('property', 'og:type', page && pathname.startsWith('/news/') && !pathname.startsWith('/news/page/') ? 'article' : 'website')
  setMeta('name', 'twitter:title', title)
  setMeta('name', 'twitter:description', description)
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (page) {
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical) }
    canonical.href = config.origin + pathname
    setMeta('property', 'og:url', canonical.href)
  } else {
    canonical?.remove()
    document.head.querySelector('meta[property="og:url"]')?.remove()
  }
  syncStructuredData(pathname)
}
